import type { MailboxInfo } from "owa-client-types";
import { isAccountFeatureEnabled, isGlobalFeatureEnabled } from "owa-feature-flags";

export default function shouldInitializeSearch(mailboxInfo: MailboxInfo): boolean {
    return (isGlobalFeatureEnabled("sea-clientWarmup") ||
        isAccountFeatureEnabled("sea-gwc-outlook-infra-latency-testing", mailboxInfo) ||
        isAccountFeatureEnabled("sea-gwc-outlook-infra-shadow-mode", mailboxInfo) ||
        isAccountFeatureEnabled("sea-gwc-query-on-type", mailboxInfo) ||
        isAccountFeatureEnabled("sea-gwc-query-on-type-with-qf", mailboxInfo) ||
        isAccountFeatureEnabled("sea-gwc-query-on-type-with-suggestions", mailboxInfo));
}
